import { Box, ContentBlock, Inline, Stack } from 'braid-design-system';

import { BackButton } from '../../components/BackButton';

interface PayAndPostErrorPageLayoutProps {
  children: React.ReactNode;
  onBackButtonClicked: () => void;
}

export const PayAndPostErrorPageLayout: React.FC<
  PayAndPostErrorPageLayoutProps
> = ({ children, onBackButtonClicked }) => (
  <ContentBlock>
    <Box marginBottom="xxlarge" marginTop="large">
      <Stack space="xlarge">
        <>{children}</>
        <Inline collapseBelow="tablet" space="xsmall">
          <BackButton onBackButtonClicked={onBackButtonClicked} />
        </Inline>
      </Stack>
    </Box>
  </ContentBlock>
);
